module.exports = __webpack_public_path__ + "img/icon-calendar.48351c1c.svg";